import { ChipProps } from "./types";

const Chip: React.FC<ChipProps> = (props) => {
  const { label, id, name, text, onClick } = props;

  return (
    <div className="">
      {label && (
        <label className="block mb-3 text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      <div className="inline-flex items-center pl-3 pr-2 py-1 mr-1 text-sm font-medium border border-yellow-300 text-yellow-800 bg-yellow-200 rounded-full">
        {text}
        <button className="ml-2 text-yellow-800 hover:text-yellow-900 focus:outline-none" onClick={() => onClick && onClick(id, name, text)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-4 h-4"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Chip;
